<template>
	<div class="navigation">

		<div class="navigation-head">
			<div class="navigation-head-logo" />
			<div
				@click="toggleNavigation()"
				class="navigation-head-hamburger"
				:class="{ 'active': this.activeNavigation }"
			>
				<span />
			</div>
		</div>

		<div class="navigation-body" :class="{ 'active': activeNavigation }">

			<div v-if="guestId" class="navigation-body-group with-line">
				<div class="navigation-body-group-login">
					<div class="navigation-body-group-login-box">
						{{ translations.labels.loggedAs }} {{ user.firstName }} {{ user.lastName }}
						<span
							@click="ajaxUnloadUser()"
							class="el-icon-circle-close"
						/>
					</div>
				</div>
			</div>

			<div class="navigation-body-group with-line">
				<h4 class="navigation-body-group-title">
					{{ translations.navigation.application }}
				</h4>
				<ul class="navigation-body-group-list">
					<li class="navigation-body-group-list-item">
						<router-link to="/devices">
							<i class="el-icon-monitor" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.devices }}
							</div>
						</router-link>
					</li>
					<li class="navigation-body-group-list-item">
						<router-link to="/presentations">
							<i class="el-icon-files" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.presentations }}
							</div>
						</router-link>
					</li>
					<li class="navigation-body-group-list-item">
						<router-link to="/schedules">
							<i class="el-icon-alarm-clock" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.schedules }}
							</div>
						</router-link>
					</li>
					<li class="navigation-body-group-list-item">
						<router-link to="/media">
							<i class="el-icon-picture-outline" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.media }}
							</div>
						</router-link>
					</li>
					<!-- <li class="navigation-body-group-list-item">
						<router-link to="/logs">
							<i class="el-icon-document" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.logs }}
							</div>
						</router-link>
					</li> -->
					<li v-if="isTeamOwner || isTeamAdmin" class="navigation-body-group-list-item">
						<router-link to="/usage">
							<i class="el-icon-odometer" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.usage }}
							</div>
						</router-link>
					</li>
				</ul>
			</div>

			<div class="navigation-body-group" :class="{ 'with-line': isAdmin() && !guestId }">
				<h4 class="navigation-body-group-title">
					{{ translations.navigation.team }}
				</h4>
				<ul class="navigation-body-group-list">
					<li class="navigation-body-group-list-item">
						<router-link to="/team/manage">
							<i class="el-icon-trophy" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.team }}
							</div>
						</router-link>
					</li>
					<li v-if="isTeamOwner || isTeamAdmin" class="navigation-body-group-list-item">
						<router-link to="/team/billing">
							<i class="el-icon-money" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.billingPayments }}
							</div>
						</router-link>
					</li>
					<li v-if="isTeamOwner || isTeamAdmin" class="navigation-body-group-list-item">
						<router-link to="/team/plans">
							<i class="el-icon-suitcase" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.plans }}
								<div v-if="objectLength(userTeam) && userTeam.plan.title === 'TRIAL'" class="navigation-body-group-list-item-title-upgrade">
									{{ translations.labels.upgrade }}
								</div>
							</div>
						</router-link>
					</li>
				</ul>
			</div>

			<div v-if="isAdmin() && !guestId" class="navigation-body-group">
				<h4 class="navigation-body-group-title">
					{{ translations.navigation.administration }}
				</h4>
				<ul class="navigation-body-group-list">
					<li class="navigation-body-group-list-item">
						<router-link to="/administration/accounts">
							<i class="el-icon-shopping-bag-2" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.accounts }}
							</div>
						</router-link>
					</li>
					<li class="navigation-body-group-list-item">
						<router-link to="/administration/vouchers">
							<i class="el-icon-present" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.vouchers }}
							</div>
						</router-link>
					</li>
					<li class="navigation-body-group-list-item">
						<router-link to="/administration/languages">
							<i class="el-icon-chat-dot-round" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.languages }}
							</div>
						</router-link>
					</li>
					<li class="navigation-body-group-list-item">
						<router-link to="/administration/environment">
							<i class="el-icon-edit-outline" />
							<div class="navigation-body-group-list-item-title">
								{{ translations.navigation.environment }}
							</div>
						</router-link>
					</li>
				</ul>
			</div>

		</div>

		<div class="navigation-footer" :class="{ 'active': activeNavigation }">
			<div class="navigation-footer-user">

				<div
					@click="activeUserMenu = !activeUserMenu"
					class="navigation-footer-user-avatar"
					:class="{ 'active': activeUserMenu }"
				>
					<v-gravatar
						:email="user.email"
						:size="72"
						alt=""
					/>
				</div>

				<div
					class="navigation-footer-user-menu"
					:class="{ 'active': activeUserMenu }"
				>
					<div class="navigation-footer-user-menu-profile">
						<div class="navigation-footer-user-menu-profile-name">
							{{ `${user.firstName} ${user.lastName}` }}
						</div>
						<div class="navigation-footer-user-menu-profile-email">
							{{ user.email }}
						</div>
					</div>
					<ul class="navigation-footer-user-menu-list">
						<li>
							<router-link to="/account/profile">
								{{ translations.navigation.profile }}
							</router-link>
						</li>
						<li>
							<router-link to="/account/security">
								{{ translations.navigation.security }}
							</router-link>
						</li>
						<li>
							<a href="https://e-screen.app/release/app.apk" target="_blank">
								Download player app
							</a>
						</li>
						<li>
							<router-link to="/help">
								{{ translations.labels.helpSupport }}
							</router-link>
						</li>
						<li>
							<a href="/" @click.prevent="logoutUser(true)">
								{{ translations.labels.signOut }}
							</a>
						</li>
					</ul>
				</div>

			</div>

			<div class="navigation-footer-team">
				<div
					v-if="objectLength(userTeam)"
					@click.prevent="openSwitchTeam()"
					class="navigation-footer-team-wrap"
					:class="{ 'with-cursor' : userTeams.length > 1 }"
				>
					<div class="navigation-footer-team-label">
						<span class="el-icon-lock" />{{ currentTeamName }}
					</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import Gravatar from 'vue-gravatar'
import { mapState } from 'vuex'

import { _getAccount } from '@/services/api/account'

import currentTeamName from '@/services/mixins/currentTeamName'
import isAdmin from '@/services/mixins/isAdmin'
import logoutUser from '@/services/mixins/logoutUser'

Vue.component('v-gravatar', Gravatar)

export default {
	name: 'Navigation',
	mixins:[
		currentTeamName,
		isAdmin,
		logoutUser
	],
	computed: {
		...mapState(['activeNavigation', 'guestId'])
	},
	data () {
		return {
			activeUserMenu: false
		}
	},
	watch: {
		'$route' () {
			this.activeUserMenu = false
		}
	},
	created () {
		window.addEventListener('click', this.closeUserMenu)
	},
	beforeDestroy () {
		window.removeEventListener('click', this.closeUserMenu)
	},
	methods: {

		ajaxUnloadUser () {
			this.$store.dispatch('setGuestId', '')
			_getAccount()
				.then(response => {
					this.$store.dispatch('setUser', response).then(() => {
						window.localStorage.removeItem('ESCREEN_GUEST')
						this.$router.go()
					})
				})
		},

		toggleNavigation () {
			this.$store.dispatch('setNavigationState', !this.activeNavigation)
		},

		closeUserMenu (e) {
			if (!this.$el.contains(e.target)) {
				this.activeUserMenu = false
			}
		},

		openSwitchTeam () {
			if (this.userTeams.length > 1) {
				this.activeUserMenu = false
				this.$store.dispatch('setShowSwitchTeam', true)
			}
		}

	}
}
</script>

<style lang="scss" scoped>
.navigation {

	&-head {

		background-color: $color-1;
		@include flex(flex, row, wrap, flex-start, center);
		height: $navigation-height;
		min-width: $navigation-width;
		width: $navigation-width;
		padding: 0 24px;
		width: 100%;
		z-index: 10;

		@include breakpoint(sm) {
			height: $navigation-height-mobile;
			padding: 0 20px;
			@include position($position: fixed, $top: 0, $left: 0);
		}

		&-logo {

			@include background-image(logo-horizontal, svg, contain, center, no-repeat);
			height: 25px;
			width: 141px;

			img {
				display: inline-block;
			}

		}

		&-hamburger {

			display: none;
			@include position($position: fixed, $top: 29px, $right: 20px);
			width: 24px;

			@include breakpoint(sm) {
				display: block;
			}

			span,
			span:before,
			span:after {
				cursor: pointer;
				height: 2px;
				width: 24px;
				background-color: #fff;
				position: absolute;
				display: block;
				content: '';
			}

			span:before {
				top: -6px;
			}

			span:after {
				bottom: -6px;
			}

			span,
			span:before,
			span:after {
				transition: all .3s ease;
			}

			&.active {

				span {
					background-color: transparent;
				}

				span:before,
				span:after {
					top: 0;
				}

				span:before {
					transform: rotate(45deg);
				}

				span:after {
					transform: rotate(-45deg);
				}

			}

		}

	}

	&-body {

		background-color: $color-1;
		height: calc(100vh - #{$navigation-height} - #{$navigation-footer});
		min-width: $navigation-width;
		overflow-y: auto;
		-webkit-overflow-scrolling: auto;
		transition: transform .3s ease;
		width: $navigation-width;
		position: relative;
		width: 100%;
		z-index: 10;

		@include breakpoint(sm) {

			border-top: 1px solid rgba(#fff,.2);
			height: calc(100vh - #{$navigation-height-mobile} - #{$navigation-footer});
			@include position($position: fixed, $top: $navigation-height-mobile, $left: 0);
			transform: translateX(-100vw);

			&.active {
				transform: translateX(0);
			}

		}

		&-group {

			padding: 24px 0;

			&.with-line {
				border-bottom: 1px solid rgba(#fff,.2);
			}

			&-title {

				color: rgba(#fff,.4) !important;
				font-size: 11px;
				font-weight: $font-weight-bold;
				letter-spacing: 2px;
				margin: 0;
				padding: 0 24px;
				text-transform: uppercase;
				user-select: none;

				@include breakpoint(sm) {
					font-size: 12px;
				}

			}

			&-list {

				@include list-reset;
				margin-top: 10px;

				&-item {

					position: relative;

					a {

						@include link-color(rgba(#fff,.7), #fff, none, none);
						display: block;
						font-size: 15px;
						line-height: 1.2;
						padding: 10px 24px 10px 52px;
						position: relative;
						@include text-truncate;

						&.router-link-active {
							background-color: darken($color-1, 5%);
							@include link-color(#fff, #fff, none, none);
						}

						@include breakpoint(sm) {
							font-size: 16px;
							line-height: 1.3;
							padding-left: 62px;
						}

						i {

							font-size: 18px;
							transform: translateY(-50%);
							@include position($position: absolute, $top: 50%, $left: 24px);

							@include breakpoint(sm) {
								font-size: 21px;
							}

						}

					}

					&-title {

						position: relative;

						&-upgrade {
							background-color: $color-4;
							border-radius: 3px;
							display: inline-block;
							font-size: 10px;
							font-weight: $font-weight-medium;
							line-height: 1;
							margin-left: 10px;
							padding: 5px 7px;
							transform: translateY(-50%);
							@include position($position: absolute, $top: 50%, $right: 0);
							text-transform: uppercase;
						}

					}

				}

			}

			&-login {

				padding: 0 20px;
				user-select: none;

				&-box {

					background-color: $navigation-login-color;
					border-radius: 4px;
					color: #fff;
					font-size: $font-size - 2;
					padding: 10px 36px 10px 10px;
					position: relative;
					@include text-truncate;
					width: calc(#{$navigation-width} - 40px);

					@include breakpoint(sm) {
						width: 100%;
					}

					.el-icon-circle-close {
						cursor: pointer;
						font-size: 17px;
						@include position($position: absolute, $top: 50%, $right: 10px);
						transform: translateY(-50%);
					}

				}

			}

		}

	}

	&-footer {

		background-color: $color-1;
		border-top: 1px solid rgba(#fff,.2);
		height: $navigation-footer;
		padding-top: 10px;
		position: relative;
		transition: transform .3s ease;
		z-index: 10;

		@include breakpoint(sm) {

			@include position($position: fixed, $bottom: 0, $left: 0);
			transform: translateX(-100vw);
			width: 100%;

			&.active {
				transform: translateX(0);
			}

		}

		&-team {

			background-color: darken($color-1, 5%);
			height: 40px;
			padding: 0 20px;
			@include position($position: absolute, $bottom: 0, $left: 0);
			user-select: none;
			width: 100%;

			&-wrap {

				@include flex(flex, row, wrap, center, center);
				height: 100%;
				text-align: center;
				width: 100%;

				&.with-cursor {

					cursor: pointer;

					.navigation-footer-team-label {

						opacity: .7;
						transition: opacity .3s ease;

						&:hover {
							opacity: 1;
						}

					}

				}

			}

			&-label {

				color: $navigation-text-color;
				@include flex(flex, row, wrap, center, center);
				font-size: $font-size - 2;
				line-height: 1.2;

				[class*='el-icon-'] {
					font-size: 15px;
					margin-right: 6px;
				}

			}

		}

		&-user {

			@include flex(flex, row, wrap, center, center);
			position: relative;

			&-avatar {

				border-radius: 50%;
				border: 2px solid rgba(255,255,255,.2);
				cursor: pointer;
				@include flex(flex, row, wrap, flex-start, center);
				padding: 3px;
				transition: border .3s ease;
				user-select: none;

				&:hover,
				&.active {
					border-color: #fff;
				}

				img {
					border-radius: 50%;
					display: block;
					height: 38px;
					width: 38px;
				}

			}

			&-menu {

				background-color: #fff;
				border-radius: 5px;
				box-shadow: 0 2px 8px rgba(0,0,0,.1);
				margin-left: -100px;
				opacity: 0;
				@include position($position: absolute, $bottom: 70px, $left: 50%);
				transition: all .2s ease;
				transform: translateY(30px) scale(0.8);
				visibility: hidden;
				width: 200px;
				z-index: 11;

				&.active {
					opacity: 1;
					transform: translateY(0) scale(1);
					visibility: visible;
				}

				&:after {
					border: solid transparent;
					border-color: rgba(255,255,255,0);
					border-top-color: #fff;
					border-width: 8px;
					left: 50%;
					content: '';
					height: 0;
					margin-left: -8px;
					pointer-events: none;
					position: absolute;
					top: 100%;
					width: 0;
				}

				&-profile {

					border-bottom: 1px solid $color-line;
					padding: 14px 16px;
					position: relative;
					user-select: none;

					&-name {
						color: darken($color-text, 10%);
						font-size: 15px;
						line-height: 1.2;
						@include text-truncate;
					}

					&-email {
						color: lighten($color-text, 20%);
						font-size: 13px;
						line-height: 1.4;
						@include text-truncate;
					}

				}

				&-list {

					@include list-reset;
					padding: 10px 0;

					li {

						a {

							@include link-color($color-text, $color-link-hover, none, none);
							display: block;
							font-size: 14px;
							padding: 6px 16px;

							&:hover {
								color: $color-1;
							}

							&.router-link-exact-active {
								background-color: $color-light-background-primary;
								color: $color-1;
							}

						}

					}

				}

			}

		}

	}

}
</style>
